import * as bootstrap5 from "bootstrap";
import { createEventListeners} from "./eventUtils";

export default (options = {}) => ({

    _cleanup: null,
    init() {
        initializeModal(this.$el, options);

        this._cleanup = createEventListeners(this.$el, {
            'close-modal': () => {
                this.closeModal()
            },
            'resize-modal': (e) => {
                this.resizeModal(e.detail.size)
            },
        });
    },
    resizeModal(to) {
        // Resize modal with boostrap class. to : xl, lg, md, sm
        const dialog = this.$el.querySelector('.modal-dialog');
        const size = to?.value ?? to;
        if (!dialog || !to) return;

        const sizes = ['modal-sm', 'modal-md', 'modal-lg', 'modal-xl'];
        sizes.forEach(size => dialog.classList.remove(size));

        dialog.classList.add(`modal-${size}`);
    },
    closeModal() {
        setTimeout(() => {
            const modal = bootstrap5.Modal.getInstance(this.$el);
            if (!modal) {
                console.error('[modal] getInstance returned null -- Bootstrap instance missing for', this.$el);
                return;
            }
            modal.hide();
        }, 0);
    },
    destroy() {
        this._cleanup?.();
    }

});

function initializeModal(modalEl, options) {

    const rawBackdrop = modalEl.dataset.bsBackdrop;
    const backdropOption = rawBackdrop === 'static' ? 'static'
        : rawBackdrop !== 'false';

    const rawKeyboard = modalEl.dataset.bsKeyboard;
    const keyBoardOption = rawKeyboard !== 'false';

    const modal = new bootstrap5.Modal(modalEl, {
        backdrop: false, // Never show the original backdrop in the body. We use our own custom backdrop instead in the shadow DOM.'
        keyboard: keyBoardOption
    });

    modal._config.backdrop = backdropOption;

    const shadowRoot = modalEl.getRootNode();
    // Show/hide our custom shadow DOM backdrop in sync with the modal
    modalEl.addEventListener('show.bs.modal', () => { if(backdropOption !== false) _showBackdrop(shadowRoot);} );
    modalEl.addEventListener('hidden.bs.modal', () => _hideBackdrop(shadowRoot));
    modalEl.addEventListener('hidden.bs.modal', () => {
        if (options.removeRootNodeAfterClose) {
            if (shadowRoot instanceof ShadowRoot) {
                modalEl.outerHTML = "";
            }
        }
    });

    // Wire data-bs-toggle triggers
    modalEl.querySelectorAll('[data-bs-toggle="modal"][data-bs-target]').forEach(btn => {
        const fresh = btn.cloneNode(true);
        btn.replaceWith(fresh);
        fresh.addEventListener('click', (e) => {
            e.preventDefault();
            const id = fresh.getAttribute('data-bs-target').replace('#', '');
            modal.show();
        });
    });

    // Wire data-bs-dismiss buttons
    modalEl.querySelectorAll('[data-bs-dismiss="modal"]').forEach(btn => {
        const fresh = btn.cloneNode(true);
        btn.replaceWith(fresh);
        fresh.addEventListener('click', () => {
            modal.hide();
        });
    });


    if (options.open)
        modal.show();
}

function _showBackdrop(shadowRoot) {
    const backdrop = shadowRoot.querySelector('.bs5-backdrop');
    if (!backdrop) return;
    backdrop._anim?.cancel();
    backdrop.style.display = 'block';
    backdrop._anim = backdrop.animate(
        [{ opacity: 0 }, { opacity: 0.5 }],
        { duration: 150, easing: 'linear', fill: 'forwards' }
    );
}

function _hideBackdrop(shadowRoot) {
    const backdrop = shadowRoot.querySelector('.bs5-backdrop');
    if (!backdrop) return;
    backdrop._anim?.cancel();
    backdrop._anim = backdrop.animate(
        [{ opacity: 0.5 }, { opacity: 0 }],
        { duration: 150, easing: 'linear' }
    );
    backdrop._anim.onfinish = () => { backdrop.style.display = 'none'; };
}